import { render, staticRenderFns } from "./update-zt.vue?vue&type=template&id=3593b49c&scoped=true&"
import script from "./update-zt.vue?vue&type=script&lang=tsx&"
export * from "./update-zt.vue?vue&type=script&lang=tsx&"
import style0 from "./update-zt.vue?vue&type=style&index=0&id=3593b49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3593b49c",
  null
  
)

export default component.exports